import React from "react";

const Down = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 4 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.364258 0.574463L1.93803 2.14823L3.51179 0.574463"
        stroke="currentColor"
        strokeWidth="0.629507"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Down;
